import React from 'react';
import { SvgIcon } from '@mui/material';

function SvgFoxtons(props) {
  return (
    <SvgIcon {...props} title="Foxtons">
      <svg
        viewBox="0 0 24 24"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.475 20.13V13.7h2.367l1.134-3.185h-3.501V7.608h3.452l1.331-2.963H8.516V20.13h2.959Z"
          fill="#017163"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 23.103c6.132 0 11.103-4.971 11.103-11.103S18.132.897 12 .897.897 5.868.897 12 5.868 23.103 12 23.103ZM12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
          fill="#017163"
        />
      </svg>
    </SvgIcon>
  );
}

export default SvgFoxtons;
